module.exports = __webpack_public_path__ + "static/img/bg-profissionais.556741e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-profissionais.jpg
// module id = 686
// module chunks = 6